import { render, staticRenderFns } from "./IncomeVerification.vue?vue&type=template&id=00e2db35&scoped=true&"
import script from "./IncomeVerification.vue?vue&type=script&lang=js&"
export * from "./IncomeVerification.vue?vue&type=script&lang=js&"
import style0 from "./IncomeVerification.vue?vue&type=style&index=0&id=00e2db35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2db35",
  null
  
)

export default component.exports